import React, { useEffect } from 'react';
import ForcedActionStatusDone from './ForcedActionStatusDone';
import { forcedActionStatus$ } from '../../reframe/h&s';
import { dispatch, useReframe } from 'nike-re-framejs';
import { useInterval } from '../../../../common/hooks/useInterval';
import { getForcedActionStatus } from './h&s';
import ForcedActionStatusBlocked from './ForcedActionStatusBlocked';
import StepRejected from '../step_errors/StepRejected';
import ForcedActionStatusPending from './ForcedActionStatusPending';
import { goToStep0 } from '../step_errors/h&s';

export const FORCED_ACTION_STATUS = {
    REQUIRED: 'required',
    BLOCKED: 'blocked',
    PENDING: 'pending',
    REJECTED: 'rejected',
    SLOT2REQUESTED: 'slot2-requested',
    DONE: 'done'
};

function StepForcedActionStatus() {
    const { subscribe } = useReframe();

    const forcedActionStatus = subscribe(forcedActionStatus$);
    useEffect(() => {
        dispatch(getForcedActionStatus);
    }, []);

    useInterval(() => {
        if (forcedActionStatus === FORCED_ACTION_STATUS.BLOCKED) {
            dispatch(getForcedActionStatus);
        } else if (forcedActionStatus === FORCED_ACTION_STATUS.REQUIRED) {
            dispatch(goToStep0());
        }
    }, 10000);

    if (forcedActionStatus === FORCED_ACTION_STATUS.BLOCKED || forcedActionStatus === FORCED_ACTION_STATUS.REQUIRED) {
        return <ForcedActionStatusBlocked />;
    }

    if (forcedActionStatus === FORCED_ACTION_STATUS.REJECTED) {
        return <StepRejected />;
    }

    if (forcedActionStatus === FORCED_ACTION_STATUS.DONE) {
        return <ForcedActionStatusDone />;
    }

    return <ForcedActionStatusPending />;
}

export default StepForcedActionStatus;
